module.exports = __webpack_public_path__ + "static/media/i9.15827b2e.svg";